function resizeBoxes(){
  console.log('box resize');
  //collection fix
  var box_width = $('.tt-product-listing .product-nohover.design-1').eq(0).width();
  if (box_width == 400) {
    box_width=305;
  }

  var target_height = parseInt(box_width/.82);
  
  // $('#same_product_height #tt-pageContent .tt-product-listing .tt-product .tt-image-box img').css('height',target_height+'px');
  // $('#same_product_height #tt-pageContent .tt-product-listing .tt-product-design02 .tt-image-box .tt-img img').css('height',target_height+'px');
  // $('#same_product_height #tt-pageContent .tt-product-listing .tt-product .tt-image-box').css('height',target_height+'px');
  // $('#same_product_height #tt-pageContent .tt-product-listing .tt-product-design02 .tt-image-box').css('height',target_height+'px');                               
  // var inline_height = target_height+85;
     

  // setTimeout(
  // function() 
  // {
  //   var inline_height = $('#same_product_height #tt-pageContent .tt-product-listing .ss__result--item:eq(0) .tt-product').height();
  //   $('#same_product_height #tt-pageContent .tt-product-listing .ss__inline-banner img').css('height',inline_height+'px');   
  // }, 500);
  
  //console.log('Carousel Sizing Original');
  var box_width = $('.p-carousel .product-nohover.design-1').eq(0).parent().width();
  var target_height = parseInt(box_width/.82);
  // $('#same_product_height #tt-pageContent .p-carousel .tt-product .tt-image-box img').css('height',target_height+'px');
  // $('#same_product_height #tt-pageContent .p-carousel .tt-product-design02 .tt-image-box .tt-img img').css('height',target_height+'px');
  // $('#same_product_height #tt-pageContent .p-carousel .tt-product .tt-image-box').css('height',target_height+'px');
  // $('#same_product_height #tt-pageContent .p-carousel .tt-product-design02 .tt-image-box').css('height',target_height+'px');                               


 //console.log('Carousel Sizing Womens');
  var box_width = $('.custom-product-carousel .product-nohover.design-1').eq(0).parent().width();
  var target_height = parseInt(box_width/.82);
  // $('#same_product_height #tt-pageContent .custom-product-carousel .tt-product .tt-image-box img').css('height',target_height+'px');
  // $('#same_product_height #tt-pageContent .custom-product-carousel .tt-product-design02 .tt-image-box .tt-img img').css('height',target_height+'px');
  // $('#same_product_height #tt-pageContent .custom-product-carousel .tt-product .tt-image-box').css('height',target_height+'px');
  // $('#same_product_height #tt-pageContent .custom-product-carousel .tt-product-design02 .tt-image-box').css('height',target_height+'px');                               


 //console.log('Carousel Sizing Mens');
  var box_width = $('.two-collection .product-nohover.design-1').eq(0).parent().width();
  var target_height = parseInt(box_width/.82);
  //console.log('width:'+box_width);
  //console.log('height:'+target_height);
  // $('#same_product_height #tt-pageContent .two-collection .tt-product .tt-image-box img').css('height',target_height+'px');
  // $('#same_product_height #tt-pageContent .two-collection .tt-product-design02 .tt-image-box .tt-img img').css('height',target_height+'px');
  // $('#same_product_height #tt-pageContent .two-collection .tt-product .tt-image-box').css('height',target_height+'px');
  // $('#same_product_height #tt-pageContent .two-collection .tt-product-design02 .tt-image-box').css('height',target_height+'px');

  var box_width = $('.customer-bought-carousel .product-nohover.design-1').eq(0).parent().width();
  var target_height = parseInt(box_width/.82);  
  $('.customer-bought-carousel .tt-product .tt-image-box img').css('height',target_height+'px');
  $('.customer-bought-carousel .tt-product-design02 .tt-image-box .tt-img img').css('height',target_height+'px');
  $('.customer-bought-carousel .tt-product .tt-image-box').css('height',target_height+'px');
  $('.customer-bought-carousel .tt-product-design02 .tt-image-box').css('height',target_height+'px');


  var box_width = $('.recently-viewed-carousel .product-nohover.design-1').eq(0).parent().width();
  var target_height = parseInt(box_width/.82);  
  $('.recently-viewed-carousel .tt-product .tt-image-box img').css('height',target_height+'px');
  $('.recently-viewed-carousel .tt-product-design02 .tt-image-box .tt-img img').css('height',target_height+'px');
  $('.recently-viewed-carousel .tt-product .tt-image-box').css('height',target_height+'px');
  $('.recently-viewed-carousel .tt-product-design02 .tt-image-box').css('height',target_height+'px');

  
  $('.recently-viewed-carousel .tt-image-box > a[href="/collections/all"]').each(function (){
      console.log('empty rv');
      $(this).closest('.forsliders-margins').remove();
  });


}

function filterSearchResults(){
      var currentConstraints = new URLSearchParams(window.location.search); 
      if(currentConstraints.has('constraint')) {
          var constraintkeys = currentConstraints.get('constraint');
          console.log('current-contstraints:'+constraintkeys);
          var constraints = constraintkeys.split(" ");
          constraints = constraints.filter(function(e){return e}); 
          console.log('Number of Constraints' + constraints.length);

          if (constraints.length>0) {



            //$('.product-nohover.design-1').hide();

            var currloc = window.location.href;
            console.log('CurrentLoc'+currloc);
            var toshowshoppingfilter = false;
            var foundcolour = 0; 
            var foundcollection = 0;

            $('#filter-collection li a').each(function (){
              var lielem = $(this);
              $.each(constraints, function(index, val) {
                if (lielem.data('tagset') == val) {
                  lielem.parent().addClass('hide');
                  var newloc = currloc.replace(val, '');
                  toshowshoppingfilter = true;
                  $('#shop_trigger .filtres-js ').prepend('<li class="padding-left-10 1 subfilter-collection"><a href="'+newloc+'"><span class="group-Collection">'+lielem.text()+'</span></a></li>');
                  foundcollection++;
                }
              });
            });

            if (foundcollection>0) {
              $('#shop_trigger .filtres-js .subfilter-collection:first-child').before('<li style="font-weight:500;">Collection:</li>');
            }



            $('#filter-colour li a').each(function (){
              var lielem = $(this);
              $.each(constraints, function(index, val) {
                if (lielem.data('tagset') == val) {              
                  lielem.parent().addClass('hide');
                  var newloc = currloc.replace(val, '');
                  toshowshoppingfilter = true;
                  $('#shop_trigger .filtres-js ').prepend('<li class="padding-left-10 1 subfilter-colour"><a href="'+newloc+'"><span >'+lielem.text().replace('color-','')+'</span></a></li>');
                  foundcolour++;                
                }
              });
            });

            if (foundcolour>0) {
              $('#shop_trigger .filtres-js .subfilter-colour:first-child').before('<li style="font-weight:500;">Colour:</li>');
            }

            //filtering

            var filterforcollection = false;
            var filterforcolors = false;

            $.each(constraints, function(index, val) {
                if (val.includes('collection-')) {
                  filterforcollection = true;
                }
                if (val.includes('color-')) {
                  filterforcolors = true;
                }
            });

            console.log('filtercollection',filterforcollection);
            console.log('filtercolor',filterforcolors);


            if (filterforcolors) {
              console.log('To filter colors',constraints);
              $('.product-nohover.design-1').each(function (){
                  var hide = true;
                  var tags = $(this).find('.product-tags').text().toLowerCase();      
                  //console.log(tags);
                  $.each(constraints, function(index, val) {
                    if (val.includes('color-')) {
                      if (tags.includes(val) == true) {
                        hide = false;
                      }
                    }
                  });

                  //console.log('hide',hide);

                  if (hide) {
                    $(this).parent().remove();
                  }
              });              
            }

            if (filterforcollection) {
              console.log('To filter collection',constraints);
              $('.product-nohover.design-1').each(function (){                              
                  var constrained = false;
                  var tags = $(this).find('.product-tags').text().toLowerCase();
                  //console.log(tags);
                  $.each(constraints, function(index, val) {
                    if (val.includes('collection-')) {    
                      console.log('checking for',constraints[index])                
                      if (tags.includes(val) == false) {
                        constrained = true;
                      }                   
                    }
                  });

                  //console.log('constrained',constrained);

                  if (constrained) {
                    $(this).parent().remove();
                  }
              });
            }

            /*

            


            */



            if (toshowshoppingfilter) {
               $('#shop_trigger').removeClass('hide');         
            }


            setTimeout(function() {
              resizeBoxes();              
              $('.search-results-div').css('opacity','1');
              console.log('Fading In Filter');
            }, 500);

          } else {
            setTimeout(function() {
              resizeBoxes();              
              $('.search-results-div').css('opacity','1');
              console.log('Fading In');
            }, 500);        
          }

          


          //regenerate the shopping by 
      } else {
        setTimeout(function() {
          resizeBoxes();              
          $('.search-results-div').css('opacity','1');
          console.log('Fading In Constraints');
        }, 500);           
      }   
}


function loadFilters(){
// COMMENT DUE TO SEARCHSPRING https://app.asana.com/0/0/1202805230704884/f

    // $('#filter-collection .tt-options-swatch li a').each(function(index, el) {      
    //     if ($(this).parent().hasClass('hide')) {
    //       //do nothing; 
    //     } else {
    //       var rangeTitle = $(this).text();
    //       $('.range-filter-mobile').append('<span class="range-filter-cta">'+rangeTitle+'</span>');          
    //     }
    // });
    // $('.clear-filters li a span').each(function(index, el) {
    //     if ($(this).hasClass('group-Collection')) {
    //       var rangeTitle = $(this).text();    
    //       $('.range-filter-mobile').prepend('<span class="range-filter-cta active">'+rangeTitle+'</span>'); 
    //     }
    // });
    
  }


$('.tt-carousel-products-js').on('init', function(event, slick, currentSlide, nextSlide){
  //carousel initialized
  console.log('carousel tt-carousel-products-js initialized');
  resizeBoxes();
});

$('.tt-carousel-products').on('init', function(event, slick, currentSlide, nextSlide){
  //carousel initialized
  console.log('carousel tt-carousel-products initialized');
  resizeBoxes();
});

$('.recently-viewed-carousel').on('init', function(event, slick, currentSlide, nextSlide){
  //carousel initialized
  console.log('carousel recently-viewed-carousel initialized');
  resizeBoxes();
});



//tt-layout-product-item





function checkPage() {
    //move the 2nd page below the banner 

    if ($('#main-blog-title').length>0) {
      var searchParams = new URLSearchParams(window.location.search); //get all parameters
      if(searchParams.has('page')) { //check if foo parameter is set to anything
          var page = parseInt(searchParams.get('page'));
          //console.log (page);
          if (page>1) {
            //console.log('Scrolling');
                
            $("#main-blog-title").get(0).scrollIntoView({ behavior: 'smooth' });
          }
          //   
      }
    }
}

var freeproductprice = 0; //global free item price

function recomputePromotions(){
  console.log('Recalculating Savings');
  
  if ($('.cart-promo-messaging-text-cart').length > 0 ) {
    console.log ('ON Cart');
        $('#subtotal td').html('<i class="fa fa-circle-o-notch fa-spin"></i>');
        $('#grandtotal td').html('<i class="fa fa-circle-o-notch fa-spin"></i>');
        $('#granddiscount td').html('<i class="fa fa-circle-o-notch fa-spin"></i>');    
        jQuery.getJSON('/cart.js', function(thecart) { 
        console.log(thecart.items);
          var freeitemid = $('.cart-promo-messaging-text-cart').attr('data-free-item-id');          
          var cartprice = 0;
          thecart.items.forEach(function(item) {
            if (parseInt(item.id) != parseInt(freeitemid)) {
              cartprice = cartprice + item.final_line_price;
            }
          });
          
          //cartprice = thecart.total_price/100;
          cartprice = cartprice/100;
          
          var targetprice = parseFloat($('.cart-promo-messaging-text-cart').data('target-orig'));
          console.log('Cart has changed '+cartprice + 'vs' + targetprice);
          var freeitem = $('.cart-promo-messaging-text-cart').data('free-item');
          var freeitemprice = parseFloat($('.cart-promo-messaging-text-cart').data('free-item-price')/100);
          var inclmsg = '';

          var furtherdisc = $('.cart-promo-messaging-text-cart').data('further-discount');
		  totaldisc = 0;
          totaldisc = thecart.total_discount;


          if ($('.cart-promo-messaging-text-cart').data('promotype') == 'getfreeitem') { //FREE ITEM PROMO
            freeproductprice = parseFloat($('.cart-promo-messaging-text-cart').data('free-item-price')/100);
            var itemincart = false;
            thecart.items.forEach(function(item) {
              if (item.id == parseInt(freeitemid)) {
                itemincart = true;
                totaldisc += (freeitemprice*100);
                //cartprice -= (freeitemprice);
                console.log('Item is in cart '+cartprice + 'vs' + targetprice);
                $('.item-'+freeitemid+' .detach-quantity-desctope').hide();
                $('.item-'+freeitemid+' .detach-quantity-mobile').hide();
                $('.item-'+freeitemid+' .js-deleteitem-ajax').hide();
                $('.item-'+freeitemid+' .saso-cart-item-line-price').css('text-decoration','line-through');
              }
            });

            if (targetprice > cartprice) { 
              //remove item from cart
              
              if (itemincart) {
                console.log('Removing the item in cart');
                Shopify.removeItem(parseInt(freeitemid),function(data){                  
                  console.log('Removal Status',data);     
                  if (data.token) {             
                    location.reload();
                  }
                });
              } else {
                console.log('Item already not in cart');
              }
            } else {
              //add item to cart
              var itemincart = false;
              thecart.items.forEach(function(item) {
                if (item.id == parseInt(freeitemid)) {
                  itemincart = true;
                }
              });
              if (!itemincart) {
                console.log('Adding the item in cart');
                const properties = {'Type':"Free"};
                //Shopify.addItem(parseInt(freeitemid), 1);
                Shopify.addItem(parseInt(freeitemid), 1, function(data){
                  if (data.id) {        
                    location.reload();                    
                  } 
                });
              } else {
                console.log('Item already in cart');
              }
            }
          } else if ($('.cart-promo-messaging-text-cart').data('promotype') == 'getmorediscount') { //DISCOUNT PROMO
            if (targetprice > cartprice) { 
            } else {              
              totaldisc += cartprice*100*(furtherdisc/100);
              //console.log('Current Cart Price',cartprice);
              cartprice = cartprice - (totaldisc/100);
              inclmsg = '<br>(Includes extra '+furtherdisc+'%!)'
            }
          }


          //console.log('Total Discount',totaldisc);
          //show this later
          totaldisc += calculateTotalDisc(thecart);                    
          //$('.carttdsc').html(getItemFormatedPrice(totaldisc)); 

          $('#subtotal td').html(getItemFormatedPrice(cartprice*100)); 
          $('#grandtotal td').html(getItemFormatedPrice(cartprice*100));
          
          //console.log('Total Discount',totaldisc);

          if (totaldisc > 0){
            if ($('.tt-shopcart-table01 tbody tr#granddiscount').length > 0) {
              $('#granddiscount td').html(getItemFormatedPrice(totaldisc));
              $('#granddiscount th').html('Total Savings '+inclmsg);
            } else {
              $('.tt-shopcart-table01 tbody').append('<tr id="granddiscount"><th>Total Savings '+inclmsg+'</th><td>'+getItemFormatedPrice(totaldisc)+'</td></tr>')
            }
          } else {
            $('#granddiscount').remove();
          }
        })

  } else if ($('.cart-promo-messaging-text').length >0) {
      
      setTimeout(function() {
        $('.cart-promo-messaging-text').html('<i class="fa fa-circle-o-notch fa-spin"></i>');
        $('.carttdsc').html('<i class="fa fa-circle-o-notch fa-spin"></i>');
        $('.carttcp').html('<i class="fa fa-circle-o-notch fa-spin"></i>');
        
        jQuery.getJSON('/cart.js', function(thecart) { 

          
          var freeitemid = $('.cart-promo-messaging-text').attr('data-free-item-id');      
          var cartprice = 0;
          thecart.items.forEach(function(item) {
            if (parseInt(item.id) != parseInt(freeitemid)) {
              cartprice = cartprice + item.final_line_price;
            }
          });
          
          //cartprice = thecart.total_price/100;
          cartprice = cartprice/100;          
          
          var targetprice = parseFloat($('.cart-promo-messaging-text').attr('data-target-orig'));
          console.log('Cart has changed '+cartprice + 'vs' + targetprice);
          var freeitem = $('.cart-promo-messaging-text').attr('data-free-item');
          var freeitemprice = parseFloat($('.cart-promo-messaging-text').attr('data-free-item-price')/100);
          var furtherdisc = $('.cart-promo-messaging-text').attr('data-further-discount');

          totaldisc = 0;

          if ($('.cart-promo-messaging-text').attr('data-promotype') == 'getfreeitem') { //FREE ITEM PROMO
            var itemincart = false;
            thecart.items.forEach(function(item) {
              if (item.id == parseInt(freeitemid)) {
                itemincart = true;
                totaldisc += (freeitemprice*100);
                //cartprice -= (freeitemprice);
                console.log('Item is in cart '+cartprice + 'vs' + targetprice);

                $('.tt-cart-list .tt-item').each(function(index, el) {
                  var cart_item  = $(this).find('.tt-title').text();
                  if (cart_item == freeitem) {
                    $(this).find('.tt-price').css('text-decoration','line-through');
                    $(this).find('.tt-item-close').hide();
                  }
                });
              }
            });
            
            if (targetprice > cartprice) { 
              $('.cart-promo-messaging-text').html('Spend '+getItemFormatedPrice((targetprice-cartprice)*100).replace('AUD','')+' more to receive an <span class="pmt-item pmt-highlight">'+freeitem+'</span> valued at '+getItemFormatedPrice(freeitemprice*100).replace('AUD','')+' (whilst stocks last)')            
              //remove item from cart
              
              if (itemincart) {
                console.log('Removing the item in carttttt');
                // Shopify.removeItem(parseInt(freeitemid), 1);
                Shopify.removeItem(freeitemid, newUpdateCart);
              } else {
                console.log('Item already not in cart');
              }
            } else {
              $('.cart-promo-messaging-text').html('Congratulations, the FREE <span class="pmt-highlight">'+freeitem+'</span> has been added to your order!')
              //add item to cart
              var itemincart = false;
              thecart.items.forEach(function(item) {
                if (item.id == parseInt(freeitemid)) {
                  itemincart = true;
                }
              });
              if (!itemincart) {
                console.log('Adding the item in cart');
                Shopify.addItem(parseInt(freeitemid), 1);
              } else {
                console.log('Item already in cart');
              }
            }
          } else if ($('.cart-promo-messaging-text').data('promotype') == 'getmorediscount') { //DISCOUNT PROMO
            if (targetprice > cartprice) { 
              $('.cart-promo-messaging-text').html('Spend '+getItemFormatedPrice((targetprice-cartprice)*100).replace('AUD','')+' more and get an extra '+furtherdisc+'% off your entire order!')
            } else {
              totaldisc += cartprice*100*(furtherdisc/100);
              //console.log('Current Cart Price',cartprice);
              cartprice = cartprice - (totaldisc/100);
              var inclmsg = '(+'+furtherdisc+'% more!)'
              $('.cart-promo-messaging-text').html('Congratulations, an additional '+furtherdisc+'% discount has been added to your order! Extra savings of '+getItemFormatedPrice(totaldisc).replace('AUD','')+' has been applied.') 
            }
          }

          totaldisc += calculateTotalDisc(thecart);          

          //show this later
          $('.carttdsc').html(getItemFormatedPrice(totaldisc)); 
          $('.carttcp').html(getItemFormatedPrice(cartprice*100)); 
          
        })
      }, 20);
  }
  else if ($('.cart-promo-messaging-text-free-shipping').length >0) {
      
      setTimeout(function() {
        console.log("TEST");
        $('.cart-promo-messaging-text-free-shipping').html('<i class="fa fa-circle-o-notch fa-spin"></i>');
        $('.carttdsc').html('<i class="fa fa-circle-o-notch fa-spin"></i>');
        $('.carttcp').html('<i class="fa fa-circle-o-notch fa-spin"></i>');
        
        jQuery.getJSON('/cart.js', function(thecart) { 

          
//           var freeitemid = $('.cart-promo-messaging-text-free-shipping').data('free-item-id');      
           var cartprice = 0;
          thecart.items.forEach(function(item) {
              cartprice = cartprice + item.final_line_price;
          });
          
          //cartprice = thecart.total_price/100;
          cartprice = cartprice/100;          
          
          var targetprice = parseFloat($('.cart-promo-messaging-text-free-shipping').data('target-orig'));
          console.log('Cart has changed '+cartprice + 'vs' + targetprice);

          totaldisc = 0;
			/*
            if (targetprice > cartprice) { 
              $('.cart-promo-messaging-text-free-shipping').html('You\'re only '+getItemFormatedPrice((targetprice-cartprice)*100).replace('AUD','')+' away from FREE Express Shipping!')
            } else {
              $('.cart-promo-messaging-text-free-shipping').html("Congratulations - you've qualified for FREE Express Shipping!") 
            }
          	*/
			if (targetprice > cartprice) { 
              $('.cart-promo-messaging-text-free-shipping').html('Spend '+getItemFormatedPrice((targetprice-cartprice)*100).replace('AUD','')+' more to unlock <strong> FREE AU Shipping </strong>')
            } else {
              $('.cart-promo-messaging-text-free-shipping').html("Congratulations! You've qualified for FREE Shipping") 
            }       
		  totaldisc += calculateTotalDisc(thecart);

          //show this later
          $('.carttdsc').html(getItemFormatedPrice(totaldisc)); 
          $('.carttcp').html(getItemFormatedPrice(cartprice*100)); 
          
        })
      }, 20);
  }
   else if ($('.cart-promo-messaging-text-target-item-discount').length >0) {
      
      setTimeout(function() {
        console.log("TEST 123");
        $('.cart-promo-messaging-text-target-item-discount').html('<i class="fa fa-circle-o-notch fa-spin"></i>');
        $('.carttdsc').html('<i class="fa fa-circle-o-notch fa-spin"></i>');
        $('.carttcp').html('<i class="fa fa-circle-o-notch fa-spin"></i>');
        
        jQuery.getJSON('/cart.js', function(thecart) { 
          
          console.log(thecart);
           var cart_item_count = 0;
           var cartprice = 0;
          thecart.items.forEach(function(item) {
             cart_item_count = cart_item_count + item.quantity;
             cartprice = cartprice + item.final_line_price;
          });
          cartprice = cartprice/100;     
          
          var targetprice = parseFloat($('.cart-promo-messaging-text-target-item-discount').data('promotype'));
          var targetdiscount = parseFloat($('.cart-promo-messaging-text-target-item-discount').data('target-discount'));
          var targetitemcount = parseFloat($('.cart-promo-messaging-text-target-item-discount').data('target-item-count'));
		 
          totaldisc = thecart.total_discount;

            if (targetitemcount > cart_item_count) { 
              if((targetitemcount-cart_item_count) == 1){
             	 $('.cart-promo-messaging-text-target-item-discount').html('Add <strong>'+ (targetitemcount-cart_item_count) +'</strong> more item to save <strong>'+ targetdiscount +'%!</strong>')
              }
              else{
              	$('.cart-promo-messaging-text-target-item-discount').html('Add <strong>'+ (targetitemcount-cart_item_count) +'</strong> more items to save <strong>'+ targetdiscount +'%!</strong>')
              }
            } else {
              $('.cart-promo-messaging-text-target-item-discount').html('<strong>Congratulations!</strong> You’ve saved a total of <strong>'+ targetdiscount +'%</strong> off your entire order! ') 
            }
		  totaldisc += calculateTotalDisc(thecart);

          //show this later
          $('.carttdsc').html(getItemFormatedPrice(totaldisc)); 
          $('.carttcp').html(getItemFormatedPrice(cartprice*100)); 
          
        })
      }, 20);
  }
  else {
  	//promo message is not on cart and not on other pages
    console.log("cart messaging is off");
    jQuery.getJSON('/cart.js', function(thecart) { 
    	//totaldisc = 0;
    	totaldisc = thecart.total_discount;
	    totaldisc += calculateTotalDisc(thecart);     
        if ($('.carttdsc').length >0) {
          $('.carttdsc').html(getItemFormatedPrice(totaldisc)); //non-cart
        }
      
      	if (totaldisc > 0){
        	if ($('.tt-shopcart-table01 tbody tr#granddiscount').length > 0) {
          	  $('#granddiscount td').html(getItemFormatedPrice(totaldisc));
		      $('#granddiscount th').html('Total Savings ');
	        } else {
    	      $('.tt-shopcart-table01 tbody').append('<tr id="granddiscount"><th>Total Savings </th><td>'+getItemFormatedPrice(totaldisc)+'</td></tr>')
        	}
	    } else {
        	$('#granddiscount').remove();
      	}
      	
    });
  
  } 
}


function calculateTotalDisc(cart) {
  totaldisc = 0;
  cart.items.forEach(function(item) {
    $.ajax({ 
      url: '/products/' + item.handle + '.js', 
      dataType: 'json',
      async: false, 
      success: function(product){         
        product.variants.forEach(function(variant) {
          if (variant.compare_at_price != null && variant.id == item.variant_id) {
           totaldisc += (variant.compare_at_price - variant.price) * item.quantity;
          }
            
        });
      } 
    });
  });
  
  return totaldisc;
}
// CRO #1
function experiment1(){
  console.log("Running experiment 1");
   var screenWidth = screen.width;
  console.log("Screen Width: "+ screenWidth);
   if(screenWidth <= 767) {
     
    // $(".pageproduct .inline-wk-link.wlbutton-js").append("<span>Favourite</span>");
    //   $( window ).scroll(function() {
    //     console.log("SCROLLING!");
    //     clearTimeout( $.data( this, "scrollCheck" ) );
    //     $.data(this, "scrollCheck", setTimeout(function() {
    //       console.log("STOPPED SCROLLING")
    //         if ($(this).scrollTop() > 116 ){ 
    //           $(".floating-add-to-cart").css("display","flex");
    //           $(".tt-input-counter").css("display","none");
    //           $(".col-item .btn-addtocart").css("display","none");
    //           $(".pageproduct .inline-wk-link.wlbutton-js").css("width","100%");
    //           $(".pageproduct .inline-wk-link.wlbutton-js").css("text-align","center");
      
    //         }
    //     }, 250) );
    //   });
    //    $(".btn-addtocart").click(function(){
    //     Shopify.addItem($(this).data("variant-id"), 1);
    //   });
    //   $(".product-size-container-cro1 .btn-addtocart").click(function(e){
    //     $(this).css("display","none");
    //     $(this).next().css("display","block");
    //     $(this).next().next().css("display","block");
    //   });
    //   $(".floating-add-to-cart").click(function(){
    //     $(".product-size-container-cro1").css("display","block");
    //     $(".gorgias-chat-key-eam2gc").css("z-index", "0");
    //   });
    //    $(".tt-close-cro1").click(function(){
    //    $(".product-size-container-cro1").css("display","none");
    //    $(".gorgias-chat-key-eam2gc").css("z-index", "2147483000");
    //   });
   }
}

jQuery(document).ready(function($) {
  
  console.log("THIS IS READY!");
  // CRO #1 Calling
  if($("body.experiment1").length > 0){
    
     experiment1();
  }
    $(document).on('focus','#filter-search',function(){
        console.log('Search Focus');
        if ($(this).closest('form').find('input[name="type"]').length<1) {
          $(this).closest('form').append('<input type="hidden" name="type" value="product">');
        }

        
    });


/*
  setTimeout(function() {
      console.log('Running constraints');
      var currentConstraints = new URLSearchParams(window.location.search); //get all parameters
      var showavailabilityfilter = false;      
      if(currentConstraints.has('filter.v.availability')) { //check if foo parameter is set to anything
          var constraintkeys = currentConstraints.get('filter.v.availability');
          console.log('Availability:'+constraintkeys);        
          var showavailabilityfilter = true;
      }


      if (showavailabilityfilter) {
        $('.product-nohover.design-1').each(function (){ 
            if ($(this).find('.tt-label-our-stock').length > 0) {
              console.log('Found it!');
              $(this).parent().remove();
            }
        });
      }      
  }, 5000);


  $('body').on('DOMSubtreeModified', '.blog-featured-banner', function(){
      checkPage();
  });

*/


  var _learnq = _learnq || [];



  $(document).on('click','.quick-add-to-cart',function(){
   var item = {
      Name: $(this).closest('.product-parent').find('.product-title').text(),
      ProductID: parseInt($(this).parent().attr('data-pr_id')),
      ImageURL: $(this).closest('.product-parent').find('.tt-img img').attr('src'),
      URL: 'https://www.doyoueven.com/products/'+$(this).closest('.product-parent').find('.product-handle').text(),
      Price: $(this).closest('.product-parent').find('.product-price .doubly').text()
    };
    _learnq.push(['track', 'Quick Added to Cart', item]);
    //console.log('track added to cart', item);
  });

  $(document).on('click','.product-size-container .tt-options-swatch li a',function(e){
    $(this).parent().addClass('active');
  });

    



  //$(document).on('click','').click(function(e) {

  //});  

  
  function getSearchParams(k){
   var p={};
   location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(s,k,v){p[k]=v})
   return k?p[k]:p;
  }


  //top filter
  

  $(document).on('click','.pagesearch .hide-filter',function(e){

    $('.aside.leftColumn').addClass('desctop-no-sidebar');
    $(".col-md-12").removeClass("col-lg-9");
    $(".col-md-12").removeClass("col-xl-9");
    $('.col-md-12').addClass('wew');
    $(".show-filter").css("display","initial");
    $(".hide-filter").css("display","none");
    initImagesSize();
    lazyload();
    //resizeBoxes();
  });


  $(document).on('click','.pagesearch .show-filter',function(e){
    console.log('showing');
    $('.aside.leftColumn').removeClass('desctop-no-sidebar');
    $(".col-md-12").addClass("col-lg-9");
    $(".col-md-12").addClass("col-xl-9");
    $(".show-filter").css("display","none");
    $(".hide-filter").css("display","initial");
    initImagesSize();
    lazyload();
    //resizeBoxes();
  });


/*
  $(document).on('click','.tt-search.123 button',function(e){ 
    console.log('mobile search opened');
    var focusEl = document.getElementById('filter-search');
    var isFocused = (document.activeElement === focusEl);
    if (!isFocused) {
      setTimeout(function () {
      //  focusEl.focus();
      }, 500);
    } else {
      console.log('focused');
    }

    // create invisible dummy input to receive the focus first
    const fakeInput = document.createElement('input')
    fakeInput.setAttribute('type', 'text')
    fakeInput.setAttribute('readonly', 'true')
    fakeInput.style.position = 'absolute'
    fakeInput.style.opacity = 0
    fakeInput.style.height = 0
    fakeInput.style.fontSize = '16px' // disable auto zoom

    // you may need to append to another element depending on the browser's auto 
    // zoom/scroll behavior
    document.body.prepend(fakeInput)

    // focus so that subsequent async focus will work
    //fakeInput.focus()

    setTimeout(() => {

      // now we can focus on the target input
      //focusEl.focus()

      // cleanup
      fakeInput.remove()
      
    }, 1000)



  })

*/  
  


  if ($('.out-of-stock-trigger').length>0) {
    console.log('found oos button');
  }



  //$(document)
  //tt-filters-options a

// COMMENT DUE TO SEARCHSPRING https://app.asana.com/0/0/1202805230704884/f
  // $(document).on('click','.range-filter-cta',function(){
  //       var sr = $(this).text();

  //       /*
  //       var params_arr = getSearchParams();
  //       console.log('params',params_arr);
  //       if (params_arr['constraint']) {
  //         console.log('has constraint');
  //       } else {
  //         console.log('no constraint');
  //       }
  //       */


  //       if ($(this).hasClass('active')) {          
  //         $('.clear-filters li a span').each(function(index, el) {
  //           if ($(this).text()==sr) {
  //               $(this).click();
                  
  //           }
  //         });
  //         $(this).removeClass('active');  
  //       } else {


  //         $('.range-filter-cta').each(function(index, el) {
  //             if ($(this).text()!=sr) {
  //               if ($(this).hasClass('active')) {
  //                 //$(this).click();
  //                   $(this).removeClass('active');
  //               }
  //             }
  //         });

  //         $('#filter-collection .tt-options-swatch li a').each(function(index, el) {  
  //           console.log($(this).text());
  //             if ($(this).text()==sr) {
  //               $(this).click();                
  //             }
  //         });
  //         $(this).addClass('active');
  //       }
  //   });  

// COMMENT DUE TO SEARCHSPRING https://app.asana.com/0/0/1202805230704884/f
  // function resetFilters() {
  //   $('.range-filter-mobile').html("");

  //   $('#filter-collection .tt-options-swatch li a').each(function(index, el) {      
  //       if ($(this).hasClass('hide')) {
  //         //do nothing; 
  //       } else {
  //         $(this).attr("id","range-filter-id-"+index);
  //         var rangeTitle = $(this).text();        
  //         $('.range-filter-mobile').append('<span class="range-filter-cta" data-target="range-filter-id-'+index+'">'+rangeTitle+'</span>');          
  //       }
  //   });


  //   $('.clear-filters li a span').each(function(index, el) {
  //     //collections
  //     console.log($(this).parent().attr('href'));
  //     if ($(this).parent().attr('href').includes('collection')) {
  //       $(this).parent().attr("id","clear-filter-id-"+index);
  //       $('.range-filter-mobile').prepend('<span class="range-filter-cta active" data-target="clear-filter-id-'+index+'">'+$(this).text()+'</span>');
  //     }

  //     //search
  //     if ($(this).parent().attr('href').includes('search')) {    
  //       $(this).parent().attr("id","clear-filter-id-"+index);
  //       var sr = $(this).text();
  //       $('.range-filter-mobile span').each(function() {
  //         if ($(this).text() == sr) {
  //           $(this).remove();
  //         }
  //       });
  //       $('.range-filter-mobile').prepend('<span class="range-filter-cta active" data-target="clear-filter-id-'+index+'">'+$(this).text()+'</span>');
  //     }
  //   }); 

    

    // $(document).on('click','.range-filter-cta',function(){
    //     if ($(this).hasClass('active')) {


    //       targetel = $(this).data('target');
    //       $('#'+targetel).click();
    //       console.log('To Clear'+targetel); 
    //       if ($('body').hasClass('pagesearch')) {
    //         var newhref = $(document).find('.clear-filters #'+targetel).attr('href');
    //         console.log(newhref);
    //         window.location.replace(newhref);
    //       } else {
    //         //$('.range-filter-mobile').html('<span style="line-height:36px;">Loading Collections...</span>');
    //         $(this).removeClass('active');
    //         setTimeout(function() {
    //           resetFilters();
    //         }, 1000);
    //       } 

    //     } else {
    //       targetel = $(this).data('target');
    //       $('#'+targetel).click();
    //       $(this).addClass('active');
    //       //$('.range-filter-mobile').html('<span style="line-height:36px;">Loading Collections...</span>');
    //       setTimeout(function() {
    //         resetFilters();
    //       }, 1000);
    //     }
    // });    
  // }


  if ($('body').hasClass('pagesearch')) {
    //
  } else {
    setTimeout(function() {
        //resetFilters();
        // loadFilters();
      }, 500);        
  }
  


  //column 1 2 switcher
  
  $(document).on('click','.column-switch i',function(event){
    $(this).toggleClass('fa-th-large');
    $(this).toggleClass('fa-square-o');
    $('.tt-product-listing.row').toggleClass('full');
    resizeBoxes();
  });





  


  $('body').on('DOMSubtreeModified', '.blog-featured-banner', function(){
      checkPage(); //blog next page scroll
  });

  $('body').on('DOMSubtreeModified', '.tt-cart-list', function(){
    //recomputePromotions();
  });
/*
  Shopify.onItemAdded = function(cart) {
    console.log('Cart Updated');
    recomputePromotions();       
  };

  Shopify.onCartUpdate = function(cart) {
    console.log('cart Updated');
    setTimeout(function() {
      recomputePromotions();      
    }, 1500);
    
  };
*/






  //$('body').on('DOMSubtreeModified', '.tt-product-listing.row', function(){
  //  console.log('Product Listing Updated');
  //  resizeBoxes(); //resize boxes on ajax pagination
  //});


  var waitForFinalEvent = (function () {
    var timers = {};
    return function (callback, ms, uniqueId) {
      if (!uniqueId) {
        uniqueId = "Don't call this twice without a uniqueId";
      }
      if (timers[uniqueId]) {
        clearTimeout (timers[uniqueId]);
      }
      timers[uniqueId] = setTimeout(callback, ms);
    };
  })();


  $(window).resize(function () {
       //resize boxes browser resize

      var win = $(this); 
      waitForFinalEvent(function(){          
          console.log('window resized');
          var boxes = $('.product-nohover.design-1').length;
          if( boxes>0 ) { 
              resizeBoxes();  
          }
      }, 100, "windowresized");
  });

  setTimeout(function() {
    //resizeBoxes();
    if ( $('.transcy-theme-postsalebautheme-searchspring').length  >0){
      resizeBoxes();
    }
    checkPage();
    recomputePromotions();
  }, 1500);

  //resizeBoxes();
  


});